/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employees_AvailabilityRuleResponse = {
    employee_id: string;
    end_time: string;
    id: string;
    kind: employees_AvailabilityRuleResponse.kind;
    start_time: string;
    valid_from: string;
    /**
     * Last day the rule applies; absent when open-ended
     */
    valid_to?: string;
    /**
     * ISO weekday, 1 = Monday ... 7 = Sunday
     */
    weekday: number;
};
export namespace employees_AvailabilityRuleResponse {
    export enum kind {
        AVAILABLE = 'available',
        UNAVAILABLE = 'unavailable',
    }
}

